const getLanguageFromLocalStorage = () => {
  return localStorage.getItem('language');
};

export { getLanguageFromLocalStorage };
